import React from "react";
import styled, { keyframes } from "styled-components";
import { Container } from "../../components/common/Container";
import {
  Section,
  EventsContainer,
  EventsGrid,
} from "./paobc-page.styles";

const pulse = keyframes`
  0%   { opacity: 1; }
  50%  { opacity: 0.4; }
  100% { opacity: 1; }
`;

const SkeletonBox = styled.div`
  background-color: #e9e8ec;
  border-radius: 8px;
  animation: ${pulse} 1.5s infinite ease-in-out;
`;

// ── Skeleton pieces ──────────────────────────────────────────────────────────

const Line = styled(SkeletonBox)<{ width?: string; height?: string }>`
  height: ${({ height }) => height ?? "14px"};
  width: ${({ width }) => width ?? "100%"};
  border-radius: 4px;
`;

const SkeletonCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 3.84px 7.679px 0 rgba(0, 0, 0, 0.08);
`;

const SkeletonCardImage = styled(SkeletonBox)`
  width: 100%;
  height: 160px;
  border-radius: 0;
`;

const SkeletonCardInfo = styled.div`
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

// ── Component ────────────────────────────────────────────────────────────────

const SkeletonCardItem = () => (
  <SkeletonCard>
    <SkeletonCardImage />
    <SkeletonCardInfo>
      <Line width="50%" height="16px" />
      <Line width="100%" height="30px" />
      <Line width="100%" height="16px" style={{ marginTop: "auto" }} />
    </SkeletonCardInfo>
  </SkeletonCard>
);

export function PaobcPageSkeleton() {
  return (
    <Container>
      <Section>
        <EventsContainer>
          <Line width="261px" height="30px" />
          <EventsGrid>
            <SkeletonCardItem />
            <SkeletonCardItem />
          </EventsGrid>
        </EventsContainer>
      </Section>
    </Container>
  );
}
